module.exports = __webpack_public_path__ + "img/f7-icon.1b7effbb.svg";